export default __webpack_public_path__ + "static/media/arrow_forward.dea9c3a9.svg";